import {combineReducers} from "assecobs-faktor-web-common/index";
import {reducer as resetFormReducer} from 'redux-form'

export default combineReducers({
    form: resetFormReducer
});
